import { useSearchParams } from 'react-router-dom';

import { ColumnLineageView } from '@/components/Lineage/ColumnLineageView';
import { Page } from '@/components/Page';

export const ColumnLineagePage = () => {
  const [searchParams] = useSearchParams();
  const uniqueIdFromParam = searchParams.get('uniqueId');
  const columnNameFromParam = searchParams.get('columnName');

  return (
    <Page title="Column Level Lineage" pageType="projectLineage">
      <div className={'relative h-full w-full overflow-hidden'}>
        <ColumnLineageView
          columnName={columnNameFromParam}
          uniqueId={uniqueIdFromParam}
          isFullScreen={true}
        />
      </div>
    </Page>
  );
};
